import { ContainerOverlay, Container } from './styles'

interface ModalProps {
    id: string
    children: any
    onClose: () => void
    openModal: boolean
    width?: string
    handleOnFinish?(): void
}

export default function ModalTerms({ id, onClose, width, openModal, children, handleOnFinish = () => { } }: ModalProps) {
    return (
        <ContainerOverlay id={id} openModal={openModal}>
            <Container
                width={width}
                openModal={openModal}
            >
                {children}
            </Container>
        </ContainerOverlay>
    )
}